import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Login from '@/pages/Login';
import OperatorSelect from '@/pages/OperatorSelect';
import Dashboard from '@/pages/Dashboard';
import ProductsList from '@/pages/ProductsList';
import ProductEditor from '@/pages/ProductEditor';
import ClientsList from '@/pages/ClientsList';
import BudgetsList from '@/pages/BudgetsList';
import ApprovedBudgetsList from '@/pages/ApprovedBudgetsList';
import BudgetCreator from '@/pages/BudgetCreator';
import BudgetDetail from '@/pages/BudgetDetail';
import BudgetEditor from '@/pages/BudgetEditor';
import ProductionList from '@/pages/ProductionList';
import ProductionDetail from '@/pages/ProductionDetail';
import Settings from '@/pages/Settings';
import ActivityHistory from '@/pages/ActivityHistory';
import ProductionModelsSettings from '@/pages/ProductionModelsSettings';
import '@/App.css';

const protect = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  useEffect(() => {
    document.title = 'Kontinuos';
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/seleccionar-operador" element={protect(<OperatorSelect />)} />
          <Route path="/dashboard" element={protect(<Dashboard />)} />

          <Route path="/clientes" element={protect(<ClientsList />)} />

          <Route path="/productos" element={protect(<ProductsList />)} />
          <Route path="/productos/nuevo" element={protect(<ProductEditor />)} />
          <Route path="/productos/:id/editar" element={protect(<ProductEditor />)} />

          <Route path="/presupuestos" element={protect(<BudgetsList />)} />
          <Route path="/presupuestos-aprobados" element={protect(<ApprovedBudgetsList />)} />
          <Route path="/presupuestos/nuevo" element={protect(<BudgetCreator />)} />
          <Route path="/presupuestos/:id/editar" element={protect(<BudgetEditor />)} />
          <Route path="/presupuestos/:id" element={protect(<BudgetDetail />)} />

          <Route path="/produccion" element={protect(<ProductionList />)} />
          <Route path="/produccion/:id" element={protect(<ProductionDetail />)} />
          <Route path="/modelos-produccion" element={protect(<ProductionModelsSettings />)} />

          <Route path="/configuracion" element={protect(<Settings />)} />
          <Route path="/historial" element={protect(<ActivityHistory />)} />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
